import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Scrollbar, EffectFade } from 'swiper/core';

SwiperCore.use([Navigation, Pagination, Scrollbar, EffectFade]);

export default (() => {
    window.addEventListener('load', () => {
      const gallery = new Swiper('.gallery-block .gallery', {
        scrollbar: {
          draggable: false,
        },
        navigation: {
          nextEl: '.gallery-block .gallery .swiper-button-next',
          prevEl: '.gallery-block .gallery .swiper-button-prev',
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
      });
    })
})()


// WEBPACK FOOTER //
// ./scripts/layout/blocks/gallery.js